import Region from "../../../../../models/Region";

class PhasingGroup {
  constructor({ start, end, id, ind, chr }) {
    this.ind = ind;
    this.indMod = (chr.id + ind) % 8;
    this.id = PhasingGroup.getId(chr, id);
    this.region = new Region(start, end, chr);
    this.variantCount = 0;
  }

  get origId() {
    return this.id.split("-")[1];
  }

  static getId(chr, id) {
    return `${chr.id}-${id}`;
  }
}

export default PhasingGroup;
